import {cookie} from "../lib/cookie";
import {writable} from 'svelte/store';
import {USER_ROLE} from "../lib/constants";

let userObject = {
    id: null,
    name: null,
    email: null,
    role: 0,
    driver_id: 0,
    transporter_id: 0,
    departments: [],
    token: null,
};

const {get, set, update, subscribe} = writable(userObject);

const user = {
    set,
    update,
    subscribe,

    getToken: () => {
        return userObject.token || '';
    },

    acronym: () => {
        if (!userObject.name) {
            return '';
        }
        return userObject.name.split(' ').map(function (item) {
            return item[0]
        }).join('');
    },

    initialize: () => {
        user.update(obj => {
            // let coo = JSON.parse(cookie.get('transfers') || "{}");
            // obj.token = coo.token;
            obj.token = cookie.get('transfers') || null;
            console.log("user.initialize()", obj.token);
            return obj;
        });
    },

    setUser: data => {
        user.update(obj => {
            obj.id = data.id;
            obj.name = data.name;
            obj.email = data.email;
            obj.token = data.token;
            obj.role = parseInt(data.role);
            obj.driver_id = data.driver_id;
            user.saveCookie();
            return obj;
        });
    },

    isGod: () => {
        return userObject.role == USER_ROLE.GOD;
    },

    isAdmin: () => {
        return userObject.role == USER_ROLE.GOD || userObject.role == USER_ROLE.ADMIN;
    },
    isDepartmentAdmin: () => {
        return userObject.role == USER_ROLE.DEPARTMENT;
    },

    isLocalsAdmin: () => {
        return [USER_ROLE.GOD, USER_ROLE.ADMIN, USER_ROLE.TRASPORTER, USER_ROLE.LOCAL_ADMIN].indexOf(userObject.role) > -1;
        // return userObject.role == USER_ROLE.GOD || userObject.role == USER_ROLE.ADMIN || userObject.role == USER_ROLE.TRANSPORTER;
    },

    isDriver: () => {
        return userObject.role == USER_ROLE.GOD || userObject.role == USER_ROLE.ADMIN || userObject.role == USER_ROLE.DRIVER;
    },

    is: (role) => {
        if (Array.isArray(role)) {
            return role.indexOf(userObject.role) > -1;
        } else {
            return userObject.role == role;
        }
    },

    // setToken: (token) => {
    //     user.update(obj => {
    //         obj.token = token;
    //         user.saveCookie();
    //         return obj;
    //     });
    // },

    clearToken: () => {
        user.update(obj => {
            obj.token = null;
            user.saveCookie();
            return obj;
        });
    },

    saveCookie: () => {
        let coo = {
            token: userObject.token,
        };
        // console.log("saveCookie", coo);
        // cookie.create('transfers', JSON.stringify(coo));
        cookie.create('transfers', userObject.token);
    },

    canViewCalendar: () => {
        return [USER_ROLE.GOD, USER_ROLE.ADMIN, USER_ROLE.DEPARTMENT, USER_ROLE.DRIVER, USER_ROLE.AIRPORT].indexOf(userObject.role) > -1;
    },

    canMakeTransfers: () => {
        return userObject.role == USER_ROLE.GOD || userObject.role == USER_ROLE.ADMIN || userObject.role == USER_ROLE.DEPARTMENT;
    },
    canEditTransfers: () => {
        return userObject.role == USER_ROLE.GOD || userObject.role == USER_ROLE.ADMIN;
    },
    canViewTransfers: () => {
        return userObject.role == USER_ROLE.GOD || userObject.role == USER_ROLE.ADMIN || userObject.role == USER_ROLE.DEPARTMENT;
    },
    canDeleteTransfers: () => {
        return userObject.role == USER_ROLE.GOD || userObject.role == USER_ROLE.ADMIN;
    },
    canViewTransferPrice: () => {
        return userObject.role == USER_ROLE.GOD || userObject.role == USER_ROLE.ADMIN || userObject.role == USER_ROLE.DEPARTMENT || userObject.role == USER_ROLE.DRIVER;
    },

    canViewLocalTransfers: () => {
        return [USER_ROLE.GOD, USER_ROLE.ADMIN, USER_ROLE.DEPARTMENT, USER_ROLE.TRANSPORTER, USER_ROLE.LOCAL_ADMIN].indexOf(userObject.role) > -1;
        // return userObject.role == USER_ROLE.GOD || userObject.role == USER_ROLE.ADMIN || userObject.role == USER_ROLE.DEPARTMENT || userObject.role == USER_ROLE.TRANSPORTER;
    },
    canMakeLocalTransfers: () => {
        return [USER_ROLE.GOD, USER_ROLE.ADMIN, USER_ROLE.DEPARTMENT, USER_ROLE.LOCAL_ADMIN].indexOf(userObject.role) > -1;
        // return userObject.role == USER_ROLE.GOD || userObject.role == USER_ROLE.ADMIN || userObject.role == USER_ROLE.DEPARTMENT;
    },
    canEditLocalTransfers: () => {
        // console.log("canEditLocalTransfers", userObject.role == USER_ROLE.GOD, userObject.role == USER_ROLE.ADMIN);
        return [USER_ROLE.GOD, USER_ROLE.ADMIN, USER_ROLE.LOCAL_ADMIN].indexOf(userObject.role) > -1;
        // return userObject.role == USER_ROLE.GOD || userObject.role == USER_ROLE.ADMIN;
    },
    // canViewLocalPrices: () => {
    //     console.log(userObject.role == USER_ROLE.GOD || userObject.role == USER_ROLE.ADMIN || userObject.role == USER_ROLE.DEPARTMENT);
    //     return userObject.role == USER_ROLE.GOD || userObject.role == USER_ROLE.ADMIN || userObject.role == USER_ROLE.DEPARTMENT;
    // },
}

export default user;